export const ACTION_NODE_WIDTH = 240;
export const ACTION_NODE_HEIGHT = 80;

export const ACTION_NODE_HEIGHT_OFFSET = 125 - ACTION_NODE_HEIGHT / 2;
export const ACTION_NODE_VERTICAL_PADDING = ACTION_NODE_HEIGHT / 2;
export const ACTION_NODE_MARGIN = 64;
export const ACTION_NODE_OFFSET = ACTION_NODE_WIDTH + ACTION_NODE_MARGIN * 2;

export const ACTOR_NODE_SECTION_HEIGHT = 125;
